<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 账户设置</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:10px 0 0 20px;">
          <el-header class="mhide">账户设置</el-header>
          <el-main v-loading="sub_loading">
            <el-row>
              <el-col :span="8">账户信息</el-col>
              <el-col :span="8"><el-form ref="userInfo" :model="userInfo" :rules="userRule" inline-message label-width="90px">
                <el-form-item label="头像">
                  <el-upload
                    v-loading="loading"
                    class="avatar-uploader"
                    accept="image/*"
                    action="https://xcx.liferiverdx.com/hpv/upload/unlogin"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>

                </el-form-item>
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="userInfo.name" :disabled="disabled" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                  <el-input v-model="userInfo.mobile" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="代理码" v-if="userInfo.isChannel == 1 && userInfo.channel.parentId == 0">
                  <el-input v-model="userInfo.channel.channelCode" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="代理名称" v-if="userInfo.isChannel == 1 && userInfo.channel.parentId == 0">
                  <el-input v-model="userInfo.channel.channelName" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="经销商码" v-if="userInfo.isChannel == 1 && userInfo.channel.parentId != 0">
                  <el-input v-model="userInfo.channel.channelCode" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="经销商名称" v-if="userInfo.isChannel == 1 && userInfo.channel.parentId != 0">
                  <el-input v-model="userInfo.channel.channelName" :disabled="true" clearable></el-input>
                </el-form-item>
                <el-form-item label="性别">
                  <el-select v-model="userInfo.gender" :disabled="disabled" placeholder="请选择性别" style="width: 100%;">
                    <el-option label="女" value="0"></el-option>
                    <el-option label="男" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="出生日期">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    v-model="userInfo.birthday"
                    :disabled="disabled"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择出生日期"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
                <!--TODO-->
                <!--<el-form-item label="用户类型">-->
                  <!--<el-input :disabled="true" clearable></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="公司名称">-->
                  <!--<el-input :disabled="disabled" clearable></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="公司地址">-->
                  <!--<el-input :disabled="disabled" clearable></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="email">-->
                  <!--<el-input :disabled="disabled" clearable></el-input>-->
                <!--</el-form-item>-->

                <el-form-item v-if="disabled">
                  <el-button type="primary" @click="disabled=false">修改信息</el-button>
                </el-form-item>
                <el-form-item v-else>
                  <el-button type="primary" @click="onSubmit">确认</el-button>
                  <el-button @click="doCancel">取消</el-button>
                </el-form-item>
              </el-form></el-col>
            </el-row>
            <!--TODO 密码修改-->
            <!--<el-row class="psd">-->
              <!--<el-col :span="8">账户安全</el-col>-->
              <!--<el-col :span="8">-->
                <!--<p>-->
                  <!--<span class="el-form-item__label" style="width: 90px;">账户密码</span>-->
                  <!--<span style="line-height: 40px;">******************</span>-->
                  <!--<el-button type="primary" style="margin-left: 25px;">修改密码</el-button>-->
                <!--</p>-->
              <!--</el-col>-->
            <!--</el-row>-->
          </el-main>
        </el-container>
      </el-container>
    </div>
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import axios from 'axios'
  import {getCookie} from "../../util/util";
  import Tabbar from '@/components/Tabbar.vue'
  export default {
    name: "setting",
    data() {
      return {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
        p_activeIndex: "5",
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        imageUrl: "/static/mine_deep.png",
        loading: false,
        sub_loading:false,
        userInfo:{},
        initUserInfo:{},
        initImageUrl:"/static/mine_deep.png",
        disabled: true,
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        userRule: {
          name: [
            { required: true, message: '姓名不能为空', trigger: 'blur' },
            { max: 50, message: '长度不能超过50位', trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      NavLeft,Tabbar,
      NavHeader,
      NavBread
    },
    // computed: {
    //   user() {
    //     return this.$store.state.user;
    //   },
    // },
    mounted() {
      if (getCookie("_token")) {
        this.getUserInfo()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.$refs.navHeader.logout()
      }
      console.log("setting")
    },
    methods: {
      getUserInfo() {
        // console.log(getCookie("_token"))
        axios.get("/hpv/user/me/1",
        ).then((response) => {
          let res = response.data;
          if (res.code == 0) {
            let user = res.user
            user.gender = user.sex + ''
            if(user.birthday.length < 6){
              user.birthday = user.birthday + '-01-01'
            }
            this.initUserInfo = this.deepClone(user)
            this.userInfo = user
            if(user.pic && user.pic != "/images/mine_deep.png"){
              this.initImageUrl = this.deepClone(user.pic)
              this.imageUrl = user.pic
            }

          } else if (res.code == 401) {
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
          }

        })
      },

      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
      },

      handleAvatarSuccess(res, file) {
        this.imageUrl = res.url;
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.loading = false
      },

      beforeAvatarUpload(file) {
        if (!file.name.toLowerCase().endsWith('jpg') && !file.name.toLowerCase().endsWith('jpeg')&& !file.name.toLowerCase().endsWith('png')) {
          this.$message.error('只支持jpg、jpeg、png格式文件！')
          return false
        }

        this.loading = true

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          this.loading = false
        }
        return isLt2M;
      },

      onSubmit() {
        this.$refs['userInfo'].validate((valid) => {
          if (valid) {
            this.sub_loading = true
            let birthday
            if(this.$store.state.user.birthday == this.userInfo.birthday){
              birthday = this.$store.state.user.birthday
            }else{
              birthday = this.userInfo.birthday
            }

            axios.put("/hpv/user", {
              name: this.userInfo.name,
              sex: this.userInfo.gender,
              birthday:birthday ,
              pic: this.imageUrl
            }, {
              headers: {
                "Content-Type": "application/json",
                'token': getCookie("_token")
              }
            }).then((res)=>{
              if (res.data.code == 0){
                this.sub_loading = false
                this.disabled = true
                this.$message.success("信息修改成功")
                this.userInfo.pic = this.imageUrl
                console.log(this.userInfo)
                this.getUserInfo()
                this.$store.commit("updateUserInfo",this.userInfo)
                this.$store.commit("updateNickName", this.userInfo.name);
              }
            })
          }
        })
      },

      doCancel() {
        this.disabled = true
        this.imageUrl = this.deepClone(this.initImageUrl)
        this.userInfo = this.deepClone(this.initUserInfo)
      },

      //深拷贝
      deepClone(obj) {
        let _obj = JSON.stringify(obj);
        return JSON.parse(_obj)
      },

    }
  }
</script>

<style scoped>
  .container >>> .el-input.is-disabled .el-input__inner {
    background-color: #ffffff;
    border-color: #ffffff;
    color: #353535;
  }
  .container >>> .el-input__inner{
    line-height: normal;
  }
  .container >>> .el-input.is-disabled .el-icon-arrow-up{
    display: none;
  }
  .el-form-item--small.el-form-item{
    margin-bottom: 10px;
  }
  .psd{
    margin-top: 25px;
    padding: 25px 0;
    border-top: 1px solid #dddddd;
  }
  .sett{margin:20px 0 0 20px;
    width: 50%;}
  .mshow{
    display: none;}
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .container {
      width: 95%;
    }

    /deep/  .el-container {
      margin-left: 0 !important;
    }

    .container .el-input.is-disabled .el-input__inner {
      background-color: #ffffff;
      border-color: #ffffff;
      color: #353535;
    }

    .container  .el-input__inner {
      line-height: normal;
    }

    .container .el-input.is-disabled .el-icon-arrow-up {
      display: none;
    }

    .el-form-item--small.el-form-item {
      margin-bottom: 10px;
    }
    /deep/ .el-dialog {
      width: 98%!important;
    }
    .psd {
      margin-top: 25px;
      padding: 25px 0;
      border-top: 1px solid #dddddd;
    }
    .el-col-8{
      margin-bottom: 20px;
      width: 90%;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }
    .mshow{
    display: inline-block;}
    .mhide{
      display: none;}
    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }
    /deep/ .navbar-right-container,/deep/ .navbar-left-container img,/deep/ .hideel{
      display: none!important;
    }
    /deep/ .out{
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    .avatar {
      width: 78px;
      height: 78px;
    }
    /deep/ .avatar-uploader .el-upload{
      border-radius: 50%;
    }


  }
</style>



// WEBPACK FOOTER //
// src/pages/user/Setting.vue